import { useEffect, useState } from 'react'
import { type Control, Controller } from 'react-hook-form'
import { Checkbox } from '~/src/components/ui/checkbox'
import useDeviceDetect from '~/src/hooks/useDeviceDetect'

interface Props {
  control: Control<any>
}

const AlsoCheck: React.FC<Props> = ({ control }) => {
  const [shop, setShop] = useState('Wayfair')
  const { isMobile } = useDeviceDetect()

  useEffect(() => {
    if (isMobile) {
      setShop('Walmart')
    } else {
      setShop('Wayfair')
    }
  }, [isMobile])

  return (
    <div className='flex items-center space-x-1.5'>
      <div className='text-xs opacity-60 md:text-sm'>Also search</div>
      <div className='flex items-center space-x-2'>
        <label className='flex items-center space-x-1'>
          <Controller
            name='compare'
            control={control}
            render={({ field }) => (
              <Checkbox
                {...field}
                onCheckedChange={field.onChange}
                defaultChecked
                value={field.value}
              />
            )}
          />
          <span className='text-xs font-semibold md:text-sm'>{shop}</span>
        </label>
      </div>
    </div>
  )
}

export default AlsoCheck
